export default {
    ticketReadBegin(state) {
        state.loading = true;
    },

    ticketReadSuccess(state, data) {
        state.loading = false;
        state.currentItem = data;
    },

    ticketReadErr(state, err) {
        state.loading = false;
        state.error = err;
    },

    ticketReadAllBegin(state) {
        state.loading = true;
    },

    ticketReadAllSuccess(state, data) {
        state.loading = false;
        state.data = data.list;
        state.totalRecords = data.total;
    },

    ticketReadAllErr(state, err) {
        state.loading = false;
        state.error = err;
    },

    ticketAddBegin(state) {
        state.loading = true;
    },

    ticketAddSuccess(state) {
        state.loading = false;
    },

    ticketAddErr(state, err) {
        state.loading = false;
        state.error = err;
    },

    ticketUpdateBegin(state) {
        state.loading = true;
    },

    ticketUpdateSuccess(state, data) {
        state.loading = false;
        // find the index of the ticket to update
        const index = state.data.findIndex(ticket => ticket.id === data.id);
        state.data.list[index] = data;
    },

    ticketUpdateErr(state, err) {
        state.loading = false;
        state.error = err;
    },

    ticketMessageAddBegin(state) {
        state.loading = true;
    },

    ticketMessageAddSuccess(state, data) {
        state.loading = false;
        state.currentItem.messages.push(data);
    },

    ticketMessageAddErr(state, err) {
        state.loading = false;
        state.error = err;
    },

    ticketCountSuccess(state, data) {
        let total = 0;
        state.ticketsCount = [{
            type: 'primary',
            icon: 'ticket',
            label: 'Total Tickets',
            key: 'total',
            total: 0,
        },
        {
            type: 'success',
            icon: 'exclamation-octagon',
            label: 'Open Tickets',
            key: 'open',
            total: 0,
        },
        {
            type: 'warning',
            icon: 'pause-circle',
            label: 'Pending Tickets',
            key: 'pending',
            total: 0,
        },
        {
            type: 'secondary',
            icon: 'check-circle',
            label: 'Closed Tickets',
            key: 'close',
            total: 0,
        }];

        if (data.length > 0) {
            // iterate over the array and find the total
            data.forEach((item) => {
                total += item.total;
                // find index by key and update the total
                const index = state.ticketsCount.findIndex(ticket => ticket.key === item.currentState);
                state.ticketsCount[index].total = item.total;
            })
            state.ticketsCount[0].total = total;
        }
    }
};